import { defineStore } from 'pinia'

import { IMenuItem } from '@/types/menu.type'

export const useMenuChildrenStore = defineStore('MenuChildrenStore', {
  state: () => ({
    childItems: [] as IMenuItem[],
    parent: '',
    isLocked: false,
  }),
  actions: {
    // Обновление массива дочерних пунктов меню
    updateMenuStore (parent?: string, newItems?: IMenuItem[]) {
      this.parent = parent || ''
      this.childItems = newItems || []
    },

    toggleLockMenu () {
      this.isLocked = !this.isLocked
    },

    setIsLocked (value: boolean) {
      this.isLocked = value
    }

  },
  getters: {
    getParentTitle: (state): string => state.parent,
    getChildItems: (state): any[] => state.childItems,
    getChildItemsCount: (state) => state.childItems.length,
    getIsLocked: (state) => state.isLocked
  }
})
